import React from 'react'
import { connect } from 'react-redux'
import Layer from './layer'
import LayerTree from './layer-tree'
import Dialog from '../../common/dialog'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'

class Layers extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 'layers'
    }
  }

  valueArrayFun = (userSettings) => {
    if (userSettings.length == 3) {
      if (!Array.isArray(userSettings[2].valueArray)) {
        return userSettings[1].valueArray;
      } else if (Array.isArray(userSettings[2].valueArray)) {
        return userSettings[2].valueArray;
      }
    } else if (userSettings[1] && userSettings[1].valueArray) {
      return userSettings[1].valueArray
    } else {
      return []
    }
  }

  render() {
    const { selectedTab } = this.state,
      { layersDictionary, userSettings, collapseLeftToolbar } = this.props
    let valueArray = this.valueArrayFun(userSettings)
    return (
      <div className='left-expanded-content-container'>
        <div className='left-expanded-header-container'>
          <span className='left-expanded-header'>Map Layers</span>
          <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
        </div>
        <div className='left-expanded-tabs-container' style={{ marginTop: 10, display: 'flex', flexWrap: 'none' }}>
          {
            this.makeLayersTab({
              tab: 'layers',
              label: 'All',
              active: '../../../../../asset/Layers_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Layers_Solid_4F4F4F_hdpi.png',
            }, '20%')
          }
          {
            this.makeLayersTab({
              tab: 'active',
              label: 'Active Layers',
              active: '../../../../../asset/Layers-Active_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Layers-Active_Solid_4F4F4F_hdpi.png',
            }, '40%')
          }
          {
            this.makeLayersTab({
              tab: 'favorite',
              label: 'Favorite Layers',
              active: '../../../../../asset/Layers-Favorite_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Layers-Favorite_Solid_4F4F4F_hdpi.png',
            }, '40%')
          }
        </div>
        {
          selectedTab === 'layers' ? <LayerTree /> :
            selectedTab === 'active' ?
              (
                <div style={{ height: 'calc(100vh - 145px)' }}
                  className='layer-node-layer-container-three'
                >
                  <div className='left-expanded-layer-title'>
                    ACTIVE LAYERS
                  </div>
                  {
                    userSettings.find(setting => setting.settingId === 1).valueArray
                      .filter(id => layersDictionary[id].parentNodes.indexOf(5) === -1)
                      .map(id => <Layer layer={layersDictionary[id]} active={true}
                        settingId={1} key={`active-layer-${id}`}
                      />)
                  }
                </div>
              ) :
              selectedTab === 'favorite' ?
                (
                  <div style={{ height: 'calc(100vh - 145px)' }}
                    className='layer-node-layer-container-three'>
                    <div className='left-expanded-layer-title'>
                      FAVORITE LAYERS
                    </div>
                    {
                      valueArray && valueArray.length > 0 &&
                      valueArray.filter(id => layersDictionary[id].parentNodes.indexOf(5) === -1)
                        .map(id => {
                          const activeSettings = this.props.userSettings.find(setting => setting.settingId === 1)
                          return <Layer layer={layersDictionary[id]}
                            active={activeSettings.valueArray.some(idVal => idVal === id)}
                            settingId={1}
                            favoriteLayersSelect={'favoriteLayers'}
                            key={`favorite-layer-${id}`} />
                        }
                        )
                    }
                  </div>
                ) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  layersDictionary: state.layersDictionary,
  userSettings: state.userSettings
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Layers)